import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
const indicatorSizeMap = {
    large: '8px',
    medium: '6px',
};
const variantMap = {
    primary: {
        backgroundColor: theme.brand.main,
        color: theme.text.main,
    },
    secondary: {
        backgroundColor: theme.text.subtle,
        color: theme.text.subtle,
    },
};
export function skillTagStyle({ inverted }) {
    return [
        ...(inverted ? [darkThemeStyle] : []),
        css({
            display: 'flex',
            gap: tokens.spacing.small,
        }),
    ];
}
export const indicatorWrapperStaticStyle = css({
    alignItems: 'center',
    display: 'inline-flex',
    gap: tokens.spacing.xsmall,
});
const indicatorStaticStyle = css({
    borderRadius: tokens.borderRadius.circle,
    display: 'block',
});
export function indicatorStyle({ size, variant }) {
    const indicatorSize = indicatorSizeMap[size];
    return [
        indicatorStaticStyle,
        css({
            backgroundColor: variantMap[variant].backgroundColor,
            height: indicatorSize,
            width: indicatorSize,
        }),
    ];
}
export function labelStyle({ size, variant }) {
    return css({
        color: variantMap[variant].color,
        fontSize: tokens.fontSizes[size],
    });
}
